

import React, { useState } from 'react';
import { ListGroup, Button, Badge, Tab, Tabs, Tooltip } from "react-bootstrap";
import { LoaderComponent } from '../components/LoaderComponent';
import { Icon } from '../components/ui/Icon';
import { useGetBouncesQuery } from '../api/bouncesAPI';
import { Bounce, BounceData } from '../api/types/bounces';
import { fromUnixTime } from 'date-fns';
import { status } from '../components/bounces/status';
import clsx from 'clsx';

interface PageProps {

}

interface BouncesListProps {
   bounces: Bounce[]
}

export const BouncesList: React.FC<BouncesListProps> = (props) => {

   const stats = build_domain_stat(props.bounces);

   return <Tabs
      defaultActiveKey="list"
      id="bounce-tabs"
      className="mb-3"
    >
      <Tab eventKey="list" title="List">
         <ListGroup>
         { props.bounces.map( (bounce) =><BounceView bounce={bounce}/>)}
         </ListGroup>
      </Tab>
      <Tab eventKey="stats-domain" title="Stats by domain">
         <BounceStatsView stats={stats.by_domain} title="Domain"/>
      </Tab>
      <Tab eventKey="stats-email" title="Stats by email">
         <BounceStatsView stats={stats.by_email} title="Email"/>
      </Tab>
    </Tabs>
}


export const BouncesPage: React.FC<PageProps> = (props) => {
   const [limit, setLimit] = useState<number>(100);
   const [offset, setOffset] = useState<number>(0);

   const {data, error, isLoading, refetch } = useGetBouncesQuery({offset: offset, limit: limit})

   const handleRefresh = ()=> {
      refetch();
   }
   console.log('bounces', data);

   let nextOffset = offset + limit + 1;
   if(data) {
      if(data.count < nextOffset) {
         nextOffset = 0;
      }
   }

   return ( 
      <React.Fragment>
         <h1>Email Bounces</h1>
         <div className='m-1'>
            <Button onClick={handleRefresh} size="sm"><Icon name='sync'/> Actualiser</Button>
            Offset <input className='input-control' onChange={(e)=> setOffset(+e.target.value) } value={offset}/>
            {nextOffset ? <Button onClick={()=>setOffset(nextOffset)} size="sm"><Icon name='arrow-right'/> Suivant</Button>   : ''}
            Limit <input className='input-control' onChange={(e)=> setLimit(+e.target.value) } value={limit}/>
         </div>
        <LoaderComponent isLoading={isLoading} error={error} />
        { data ? <div>
               <span>{data.count} results</span> {offset} / {limit}
               <BouncesList bounces={data.results} />
            </div> 
         : ''}
      </React.Fragment>
   )
};

export interface BounceProps  {
   bounce: Bounce
}

export const BounceView: React.FC<BounceProps> = (props) => {
   const b = props.bounce;
   return <div className='list-group-item'>
      <Badge className='me-1 bounce-id' bg="secondary">{b.id}</Badge>
      <Badge className='me-1'>{b.mailer}</Badge>
      <span className='me-1 bounce-date'>{fromUnixTime(b.time).toLocaleDateString() }</span>
      <span className="me-1 bounce-recipient">{b.recipient}</span>
      <span className='bounce-subject ms-1'>{b.subject}</span>
     {b.bounce ? <BounceDataView bounce={b.bounce}/> : ''}
   </div>;
}

export interface BounceDataProps  {
   bounce: BounceData
}

export const BounceDataView: React.FC<BounceDataProps> = (props) => {
   const b = props.bounce;
   return <div>
      <Badge className='me-1' bg="danger">{b.action}</Badge>
      <Badge className='me-1' bg="warning">{b.type}</Badge>
      {b.diagnostic ? <span className='bounce-diagnostic me-1'>{b.diagnostic.type}  {b.diagnostic.text}</span> : ''}
      {b.status ? <span className="bounce-status">
         <Badge className='me-1' bg="info">{b.status.code}</Badge>   
         <span className='me-1'>{b.status.class}</span>
         <span className='me-1'>{b.status.subclass}</span>
      </span>: ''}
   </div>;
}

class BounceCounter {
   status_code: Map<string, number>;

   constructor() {
      this.status_code = new Map();
   }

   inc(m: Map<string,number>, key:string) {
      const v = m.get(key) ?? 0;   
      m.set(key, v + 1);
   }

   update(b: Bounce) {
      if(b.bounce && b.bounce.status) {
         const code = b.bounce.status.code;
         if(code) {
            this.inc(this.status_code, code);
         }
      }
   }
}

interface BounceStats {
   by_domain: Map<string,BounceCounter>
   by_email: Map<string,BounceCounter>
}


const build_domain_stat = (data: Bounce[]):BounceStats =>{
   const by_domain = new Map<string, BounceCounter>();
   const by_email = new Map<string, BounceCounter>();

   const update_counter = (b: Bounce, counters:Map<string, BounceCounter>, key:string) =>{
      let m = counters.get(key);
      if(!m) {
         m = new BounceCounter();
         counters.set(key, m);
      }
      m.update(b);
   }

   data.forEach(b => {
      const r = b.recipient;
      const domain = r.substring(r.lastIndexOf('@'));
      update_counter(b, by_domain, domain);
      update_counter(b, by_email, r);
   });
   return { by_domain: by_domain, by_email: by_email};
}

export interface BounceStatsProps  {
   stats: Map<string, BounceCounter>
   title: string
}

export const BounceStatsView: React.FC<BounceStatsProps> = (props) => {
   
   const [selected, setSelected] = useState<string|undefined>(undefined);
   
   const stats = props.stats;

   console.log(stats);

   const codes = new Set<string>();
   
   stats.forEach(counter => {
      Array.from(counter.status_code.keys()).forEach(v=>codes.add(v))
   });

   const code_list = Array.from(codes.values());

   console.log('codes', code_list);

   const get_subclass = (code: string):string => {
      const i = code.indexOf('.');
      const klass = code.substring(0, i - 1 );
      const sub = code.substring(i + 1);
      console.log(klass, sub);
      const r = status.subclass[sub] ?? undefined;
      if(r) {
         return r.title;
      }
      return '';
   }

   return <table className="bounce-stats-table table table-bordered" style={{"width":"auto"}}>
        <tr>
            <td>
               {props.title}
               <span onClick={()=>setSelected(undefined)}><Icon name="filter-circle-xmark"/></span>
            </td>
            { code_list.map(code => {
                  const sub = get_subclass(code);
                 return <td key={code} className="bounce-status-col">
                           <span className="bounce-status-code">{code}</span>
                           <span onClick={()=>setSelected(code)} className={clsx({"status-selected": code===selected})}><Icon name="filter" size='xs'/></span>
                           <br/>
                           <span className="bounce-status-desc">{sub}</span>
                        </td>   
               })}
         </tr>
         {
            Array.from(stats.entries()).map(e =>{
               const counter = e[1];
               const key = e[0];
               
               if(selected) {
                  if(!counter.status_code.has(selected)) {
                     return '';
                  }
               }

               return <tr key={key}>
                  <td>{key}</td>
                  { code_list.map( code => {
                     const count = counter.status_code.get(code);
                     return <td key={code}>{count}</td>
                  }) }
               </tr>
            })
         }
      </table>
}
